<nz-drawer [nzClosable]="true" [nzVisible]="showEstimationDrawer" nzPlacement="right" [nzWidth]="'400px'"
  nzTitle="Nuevo folio de estimación" (nzOnClose)="close()">
  <form nz-form *nzDrawerContent class="create-estimation-form" [formGroup]="createEstimationForm">
    <div class="form-fields">
      <nz-form-item>
        <nz-form-control nzExtra="Ingresa al menos 3 caracteres.">
          <nz-form-label nzRequired nzFor="project">Proyecto</nz-form-label>
          <nz-input-group [nzSuffix]="searchProjectIconTemplate">
            <input nz-input id="project" formControlName="project" placeHolder="Busca un proyecto"
              [nzAutocomplete]="projectAutocomplete" (input)="onSearchProject($event)">
            <nz-autocomplete #projectAutocomplete (selectionChange)="onSelectProject($event)">
              @for (project of projects; track project) {
              <nz-auto-option [nzValue]="project" [nzLabel]="project.projectName">
                {{ project.projectName }}
              </nz-auto-option>
              }
            </nz-autocomplete>
             <ng-template #searchProjectIconTemplate>
              @if (isSearchingProjects) {
              <span nz-icon nzType="loading" nzTheme="outline"></span>
              }
            </ng-template>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <nz-form-label for="company">Compañía</nz-form-label>
          <input nz-input id="company" formControlName="company" nzPlaceHolder="Selecciona una compañía">
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control nzExtra="Ingresa al menos 3 caracteres.">
          <nz-form-label nzRequired for="provider">Proveedor</nz-form-label>
          <nz-input-group [nzSuffix]="searchProviderIconTemplate">
            <input nz-input id="provider" formControlName="provider" placeHolder="Busca un proveedor"
              [nzAutocomplete]="providerAutocomplete" (input)="onSearchProvider($event)">
            <nz-autocomplete #providerAutocomplete (selectionChange)="onSelectProvider($event)">
              @for (provider of providers; track provider.id) {
              <nz-auto-option [nzValue]="provider">
                {{ provider.providerKey }} - {{ provider.providerFirstName }} {{ provider.providerLastName }}
              </nz-auto-option>
              }
            </nz-autocomplete>
            <ng-template #searchProviderIconTemplate>
              @if (isSearchingProviders) {
              <span nz-icon nzType="loading" nzTheme="outline"></span>
              }
            </ng-template>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <nz-form-label nzRequired for="type">Tipo</nz-form-label>
          <nz-select formControlName="type" id="type" nzPlaceHolder="Selecciona un tipo">
            @for (type of types; track type) {
            <nz-option [nzValue]="type.id" [nzLabel]="type.label"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <nz-form-label nzRequired for="description">Descripción</nz-form-label>
          <nz-textarea-count [nzMaxCharacterCount]="300">
            <textarea formControlName="description" nz-input id="description" rows="3" [maxlength]="300"></textarea>
          </nz-textarea-count>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div class="create-estimation-button-container">
      <button nz-button nzType="primary" class="create-estimation-button" [disabled]="!createEstimationForm.valid"
        (click)="onCreateEstimation()">
        <span nz-icon nzType="arrow-right"></span>
        Crear e ir a la estimación
      </button>
    </div>
  </form>
</nz-drawer>